import { render, staticRenderFns } from "./waitPay.vue?vue&type=template&id=4a5048a6&scoped=true&"
import script from "./waitPay.vue?vue&type=script&lang=js&"
export * from "./waitPay.vue?vue&type=script&lang=js&"
import style0 from "./waitPay.vue?vue&type=style&index=0&lang=css&"
import style1 from "./waitPay.vue?vue&type=style&index=1&id=4a5048a6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5048a6",
  null
  
)

export default component.exports